import { perfilLabels } from "@enums/Usuario/Index";
import React from "react";

const perfis = Object.keys(perfilLabels);

const radioStyle = {
  width: "20px",
  height: "20px",
  accentColor: "#2b97be",
  marginRight: "0.5rem"
};

const PerfilRadioFilter = ({ value, onChange, title = "Filtrar por Perfil", inline = false }) => (
  <div className="border rounded p-3 bg-light">
    <h2>{title}</h2>
    <div style={{ display: inline ? "flex" : "block", gap: inline ? "2rem" : undefined }}>
      {perfis.map((perfil) => (
        <div key={perfil} className="mt-2">
          <label style={{ display: "flex", alignItems: "center", gap: "0.7rem" }}>
            <input
              type="radio"
              value={perfil}
              checked={value === perfil}
              onChange={() => onChange(perfil)}
              style={radioStyle}
            />
            {perfilLabels[perfil]}
          </label>
        </div>
      ))}
      {/* Adiciona uma opção para "Todos" */}
      <div className="mt-2">
        <label style={{ display: "flex", alignItems: "center", gap: "0.7rem" }}>
          <input
            type="radio"
            value=""
            checked={value === "" || value === undefined}
            onChange={() => onChange("")}
            style={radioStyle}
          />
          Todos
        </label>
      </div>
    </div>
  </div>
);

export default PerfilRadioFilter;
